import React, { Fragment, useContext, useEffect, useState } from "react";
import Bulk from "./../Bulk/Bulk";
import Basket from "./../Basket/Basket";
import style from "./../Order.module.scss";
import { Container, Row, Col, CustomInput, Input, FormGroup, Label } from "reactstrap";
import { accountProps, customFetchAssetInfo, customFetchAccountInfo } from "./commons";
import {
  OrderPriceType,
  TimeFrame,
  ProductType,
  Type,
  Mode,
  OrderStatus,
} from "../../../../utils/Order/Order";
import { Field, Symbol, Account, Numeric, Combobox, Switch, TimeForce, PriceType } from "../Field/Field";
import { UserType } from "../../../../utils/Helper";
import { Dispatch } from "../store/store";
import { onChange, onAccountChange } from "../Order";
import QuantityHelper from "../Helper/QuantityHelper";
import { toDateLocal } from "../../../../utils/Helper";
import Booktype from "../Field/Booktype";

const MFunds = ({
  maxDecimals,
  booktypes,
  platformRole,
  opsViewAccountName,
  fetchOrderSettlementDays,
  GetDayFundProcessDate,
}) => {
  const { dispatch, state, services } = useContext(Dispatch);
  const { order, fields, ui, entities, wizzard } = state;
  const { editable, errors, readonly, hiddens } = fields;
  const [orderDate, setOrderDate] = useState(order.OrderSettlementDate || null); // useState(toDateLocal(new Date()));
  const [orderProcessDate, setOrderProcessDate] = useState(order.OrderProcessDate || null);

  const isMultiAccounts = order.OrderHasMultipleAccounts;
  const isFundCloseType = order.AssetFundType && order.AssetFundType == "Close";

  const isFullLiq = !isMultiAccounts && order.OrderSide == "Sell" && order.CurrentAccount.IsFullLiquidation;
  useEffect(() => {
    if (order.OrderId == 0) {
      onChange(dispatch, { OrderQuantityIsCash: "true" });
    }
  }, []);
  useEffect(() => {
    if (order.OrderSettlementDate) {
      setOrderDate(order.OrderSettlementDate);
    }
  }, [order.OrderSettlementDate]);

  useEffect(() => {
    if (order.OrderProcessDate) {
      setOrderProcessDate(order.OrderProcessDate);
    }
  }, [order.OrderProcessDate]);

  const isNewOrder = !order.hasOwnProperty("OrderId");

  useEffect(() => {
    if (!isNewOrder || !order.AssetTicker || state.precheck.Success) return;
    if(!GetDayFundProcessDate){
      const today = new Date().toISOString().slice(0, 10);
      setOrderProcessDate(today);
      return;
    }
    const handler = setTimeout(() => {
      GetDayFundProcessDate(order)
        .then((res) => {
          if (
            res &&
            res.response &&
            res.response.result &&
            res.response.result.Code === 200 &&
            res.response.EndDate
          ) {
            onChange(dispatch, { OrderProcessDate: res.response.EndDate })
            setOrderProcessDate(res.response.EndDate);
          } else {
            const today = new Date().toISOString().slice(0, 10);
            onChange(dispatch, { OrderProcessDate: today })
            setOrderProcessDate(today);
          }
        })
        .catch((err) => {
          console.error("Error en GetDayFundProcessDate:", err);
          const today = new Date().toISOString().slice(0, 10);
          setOrderProcessDate(today);
        });
    }, 500);

    return () => clearTimeout(handler);
  }, [order.AssetTicker]);

  useEffect(() => {
    if (order.AssetId && ui.mode !== Mode.READONLY && !order.OrderSettlementDate) {
      const updateSettlementDate = async () => {
        if (order.AssetId) {
          const payload = {
            AssetId: order.AssetId,
            ParentOrderSide: order.OrderSide,
            OrderProcessDate: order.OrderInitDate,
          };

          try {
            const settlementData = await fetchOrderSettlementDays(payload);
            if (settlementData && settlementData.response && settlementData.response.orderSettlementDate) {
              onChange(dispatch, { OrderSettlementDate: settlementData.response.orderSettlementDate });
              setOrderDate(settlementData.response.orderSettlementDate);
            }
          } catch (error) {
            console.error("Error fetching settlement date:", error);
            onChange(dispatch, { OrderSettlementDate: toDateLocal(new Date()) });
            setOrderDate(toDateLocal(new Date()));
          }
        } else if (order.OrderSettlementDate) {
          setOrderDate(order.OrderSettlementDate);
        } else {
          onChange(dispatch, { OrderSettlementDate: toDateLocal(new Date()) });
          setOrderDate(toDateLocal(new Date()));
        }
      };
      updateSettlementDate();
    }
  }, [order.AssetId, dispatch]);

  useEffect(() => {
    if (!isNewOrder || !order.AssetId || !orderProcessDate || state.precheck.Success) return;
    const updateSettlement = async () => {
      try {
        const payload = {
          AssetId: order.AssetId,
          ParentOrderSide: order.OrderSide,
          OrderProcessDate: orderProcessDate,
        };
        const settlementData = await fetchOrderSettlementDays(payload);

        if (settlementData && settlementData.response && settlementData.response.orderSettlementDate) {
          onChange(dispatch, {
            OrderSettlementDate: settlementData.response.orderSettlementDate,
          });
          setOrderDate(settlementData.response.orderSettlementDate);
        }
      } catch (error) {
        console.error("Error recalculando settlement date:", error);
      }
    };
    updateSettlement();
  }, [orderProcessDate, order.AssetId, order.OrderSide, dispatch, fetchOrderSettlementDays]);

  const accountInfo = (props, updateOrderValues) =>
    customFetchAccountInfo(
      dispatch,
      services.account,
      {
        ...order,
        CurrentAccount: {
          ...order.CurrentAccount,
          ...props,
        },
      },
      updateOrderValues
    );

  let quantities = [];
  let quantityTitle = <span>Quantity</span>;
  if (ui.type == Type.Default || ui.type == Type.Chained || ui.type == Type.Cross) {
    if (order.CurrentAccount.Day) {
      quantities = order.CurrentAccount.Day.map((day) => {
        return {
          date: day.Date,
          status: day.Status,
          quantity: parseFloat(day.AssignedQty),
        };
      });
    }
    quantityTitle = (
      <Fragment>
        <span>Quantity</span>
        {quantities.length > 0 && order.OrderId > 0 && (
          <QuantityHelper quantities={quantities} name="general">
            <i className="icon-info icons" />
          </QuantityHelper>
        )}
      </Fragment>
    );
  }

  const quantityMaxDecimals = order.OrderQuantityIsCash
    ? 2
    : parseInt(order.SubAssetClassDecimalPlaces, 10) || 5;

  // only apply for chained orders, check if 2nd order step
  let isSwitchFirstOrder = false;
  let wizzStep = 1;
  if (wizzard.enabled) {
    if (wizzard.activeStep === 2) {
      wizzStep = 2;
      isSwitchFirstOrder = order.OrderIsSwitch;
    }
  }

  return (
    <div className={style.form}>
      <Container>
        <Row>
          {/* Left */}
          <Col xs={12} lg={6}>
            {/* ##### Symbol ###### */}
            <Field label={"Symbol"} error={errors.AssetTicker}>
              <Symbol
                form={order.AssetClassForm}
                onChange={(v) => onChange(dispatch, v)}
                placeholder={"Symbol"}
                hideInfo={false}
                disabled={readonly.AssetTicker || (order.offer && +order.offer.OfferId > 0)}
                invalid={!!errors.AssetTicker}
                value={order.AssetTicker}
                description={order.AssetDescription}
                provider={order.AssetSecurityProvider}
                assetid={order.AssetId}
                attrId={"AssetId"}
                attrTicker={"AssetTicker"}
                attrDescription={"AssetDescription"}
                attrProvider={"AssetSecurityProvider"}
                {...services.symbol}
                assetInfo={() => customFetchAssetInfo(dispatch, services.symbol, order)}
                maxChar={30}
              />
            </Field>

            <Row>
              {/* ##### Trade Currency ###### */}
              <Col lg={6}>
                <Field label={"Trade Currency"} error={errors.OrderCurrencySymbol}>
                  <Input
                    type="text"
                    placeholder="Trade Currency"
                    value={order.OrderCurrencySymbol || ""}
                    disabled
                  />
                </Field>
              </Col>
              {/* ##### Settlement Currency ###### */}
              <Col lg={6}>
                <Field label={"Settlement Currency"} error={errors.OrderSettlementCurrencySymbol}>
                  <Combobox
                    value={order.OrderSettlementCurrencyId || 0}
                    items={entities.settlementCurrencies}
                    disabled={readonly.OrderSettlementCurrencySymbol}
                    invalid={!!errors.OrderSettlementCurrencySymbol}
                    onChange={(v) => onChange(dispatch, { OrderSettlementCurrencyId: v })}
                    emptyLabel={"Settlement Currency"}
                  />
                </Field>
              </Col>
            </Row>
            {ui.type === Type.Chained && (
              <Row>
                <Col>
                  <Field error={false}>
                    {wizzStep === 1 && (
                      <Switch
                        label="Is switch?"
                        value={order.OrderIsSwitch}
                        disabled={readonly.OrderIsSwitch}
                        onChange={(v) => onChange(dispatch, { OrderIsSwitch: v })}
                      />
                    )}
                    {isSwitchFirstOrder && (
                      <label className="d-inline-block mt-2 text-primary" style={{ fontWeight: 500 }}>
                        Switch is active
                      </label>
                    )}
                  </Field>
                </Col>
              </Row>
            )}
            <Row>
              {/* ##### Quantity Type ###### */}
              <Col lg={6}>
                <Field label={"Quantity Type"} error={errors.OrderQuantityIsCash}>
                  <Combobox
                    value={parseQuantityIsCash(order.OrderQuantityIsCash)}
                    items={[
                      { id: "false", description: "Shares" },
                      { id: "true", description: "Cash" },
                    ]}
                    disabled={readonly.OrderQuantityIsCash || isFullLiq || isSwitchFirstOrder}
                    onChange={(v) => onChange(dispatch, { OrderQuantityIsCash: v == "true" })}
                    emptyLabel={"Type"}
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                  />
                </Field>
              </Col>

              <Col lg={6}>
                <Field label={quantityTitle} error={isFullLiq ? null : errors.OrderQuantity}>
                  <Numeric
                    value={order.OrderQuantity}
                    placeholder={"Quantity"}
                    disabled={
                      readonly.OrderQuantity || isFullLiq || ui.isBulk || ui.isBasket || isSwitchFirstOrder
                    }
                    onChange={(v) => onAccountChange(dispatch, { Quantity: v })}
                    invalid={!isFullLiq && !!errors.OrderQuantity}
                    dataTypeDecimalName="quantity"
                  />
                </Field>
              </Col>
            </Row>

            {order.OrderSide == "Sell" && !ui.isBulk && !ui.isBasket && (
              <div style={{ textAlign: "right" }}>
                <CustomInput
                  label="Full liquidation"
                  type="checkbox"
                  id={`cbox-order`}
                  checked={order.CurrentAccount.IsFullLiquidation || false}
                  disabled={readonly.IsFullLiquidation || isSwitchFirstOrder}
                  onChange={(v) =>
                    onAccountChange(dispatch, {
                      IsFullLiquidation: !order.CurrentAccount.IsFullLiquidation,
                    })
                  }
                />
              </div>
            )}

            {/* ##### Price Type ###### */}
            <PriceType
              type={order.OrderType}
              form={isFundCloseType ? ProductType.BOND : ProductType.MFUNDS}
              currency={order.OrderCurrencySymbol}
              values={{
                limPrice: order.OrderPrice,
                stopPrice: order.OrderStopPrice,
              }}
              oldValues={{
                limPrice: order.HasOriginalOrReplacingData
                  ? order.OriginalOrReplacingData.OrderPrice
                  : order.OrderPrice,
                stopPrice: order.HasOriginalOrReplacingData
                  ? order.OriginalOrReplacingData.OrderStopPrice
                  : order.OrderStopPrice,
              }}
              editable={{
                limPrice: editable.OrderPrice && order.OrderStatus === OrderStatus.ACKED,
                stopPrice: editable.OrderStopPrice && order.OrderStatus === OrderStatus.ACKED,
              }}
              errors={{
                type: errors.OrderType,
                limPrice: errors.OrderPrice,
                stopPrice: errors.OrderStopPrice,
              }}
              readonly={{
                type: readonly.OrderType,
                limPrice: readonly.OrderPrice,
                stopPrice: readonly.OrderStopPrice,
              }}
              onChange={(v) => onChange(dispatch, v)}
            />

            {/* ##### TimeForce ###### */}
            <TimeForce
              date={order.OrderGTD}
              timeForce={order.OrderTimeInForce}
              errors={{
                date: errors.OrderGTD,
                timeForce: errors.OrderTimeInForce,
              }}
              readonly={{
                date: readonly.OrderGTD,
                timeForce: readonly.OrderTimeInForce,
              }}
              onChange={(v) => onChange(dispatch, v)}
            />

            {(ui.userRole === "Trader" || (ui.userRole !== "Trader" && ui.mode !== Mode.EDIT)) && (
              <Booktype
                booktypes={booktypes}
                booktype={order.BookType}
                balancetype={order.CurrentAccount.BalanceType}
                errors={{
                  BookType: errors.BookType,
                  BalanceType: errors.BalanceType,
                }}
                readonly={{
                  BookType: readonly.BookType,
                  BalanceType: errors.BalanceType,
                }}
                onChange={(v) => onChange(dispatch, v)}
                onAccountChange={(v) => onAccountChange(dispatch, v)}
              />
            )}
          </Col>

          {/* Right */}
          <Col xs={12} lg={6}>
            {/* ##### Account ###### */}
            {!ui.isBulk && !ui.isBasket && (
              <Account
                userType={ui.userRole}
                platformRole={platformRole}
                onChange={(v) => onAccountChange(dispatch, v)}
                balanceReady={!!order.AssetId}
                dispatch={dispatch}
                {...services.account}
                accountInfo={accountInfo}
                {...accountProps({ order, readonly, errors })}
                hiddens={{
                  Quantity: true,
                  ...hiddens,
                }}
                opsViewAccountName={opsViewAccountName}
              />
            )}
            {ui.isBulk && (
              <Bulk
                balanceReady={!!order.AssetId}
                onChange={(v) => onAccountChange(dispatch, v)}
                accounts={order.Accounts || []}
                isReadOnly={ui.mode == Mode.READONLY}
                canModifyComposition={ui.mode == Mode.EDIT}
                readonly={readonly}
                error={errors.Accounts}
                account={order.CurrentAccount}
                {...services.account}
                accountInfo={accountInfo}
                hiddens={hiddens}
              />
            )}
            {ui.isBasket && (
              <Basket
                balanceReady={!!order.AssetId}
                onChange={(v) => onAccountChange(dispatch, v)}
                accounts={order.Accounts || []}
                isReadOnly={ui.mode == Mode.READONLY}
                canModifyComposition={ui.mode == Mode.EDIT}
                readonly={readonly}
                error={errors.Accounts}
                account={order.CurrentAccount}
                {...services.account}
                accountInfo={accountInfo}
                hiddens={hiddens}
              />
            )}
            {/* Process date */}
            {order.OrderSide == "Sell" && order.FundX && (
              <FormGroup>
                <Label style={{ fontSize: "12px", fontWeight: 500, marginBottom: "3px" }} for="orderDate">
                  Process Date
                </Label>
                <Input
                  type="date"
                  name="date"
                  id="orderProcessDate"
                  placeholder="date placeholder"
                  disabled={!isNewOrder}
                  onChange={(e) => onChange(dispatch, { OrderProcessDate: e.target.value })}
                  value={orderProcessDate}
                />
                <Label style={{ fontSize: "12px", fontWeight: 500, marginBottom: "3px" }} for="orderDate">
                  Settlement Date
                </Label>
                <Input
                  type="date"
                  name="date"
                  min={order.OrderSettlementDate || ""}
                  id="orderDate"
                  placeholder="date placeholder"
                  disabled={!isNewOrder}
                  onChange={(e) => onChange(dispatch, { OrderSettlementDate: e.target.value })}
                  value={orderDate}
                />
              </FormGroup>
            )}
            _
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const parseQuantityIsCash = (qType) => {
  return qType === "true" || qType === true ? "true" : "false";
};

export const defaultValues = () => {
  return {
    OrderSide: "Buy",
    BookType: "Self",
    OrderQuantityIsCash: "true",
  };
};

export const validations = (order, userType) => {
  const filteredBankAccounts = order.CurrentAccount.clientBankAccounts
    ? order.CurrentAccount.clientBankAccounts.filter(
        (account) => account.currencyISO === order.OrderCurrencySymbol
      )
    : [];

  const isMultiAccounts = order.OrderHasMultipleAccounts;

  const isFullLiq = !isMultiAccounts && order.OrderSide == "Sell" && order.CurrentAccount.IsFullLiquidation;
  let maxPartialRedemption = null;
  let percentage = null;

  try {
    maxPartialRedemption = order.OrderAssetData.items["Max Partial Redemption Percentage"];
    let refPrice = order.OrderAssetData.items["Ref Price Default"];
    if (order.CurrentAccount.AccountAssetBalance == 0) {
      percentage = 0;
    } else {
      if (order.OrderQuantityIsCash) {
        percentage =
          ((order.OrderQuantity / refPrice) * 100) / parseFloat(order.CurrentAccount.AccountAssetBalance);
      } else {
        percentage = (order.OrderQuantity * 100) / parseFloat(order.CurrentAccount.AccountAssetBalance);
      }
    }
  } catch (error) {
    console.error(error);
  }

  return {
    OrderQuantity: {
      empty: !isMultiAccounts && !isFullLiq,
      exceedPartialRedemption:
        maxPartialRedemption != null &&
        maxPartialRedemption >= 1 &&
        order.OrderSide == "Sell" &&
        percentage > maxPartialRedemption &&
        !isFullLiq,
    },
    AssetTicker: { empty: true, autosuggestId: "AssetId" },
    OrderType: { empty: true },
    OrderPrice: {
      empty: order.OrderType == OrderPriceType.LIMIT || order.OrderType == OrderPriceType.STOPLIMIT,
    },
    OrderStopPrice: {
      empty: order.OrderType == OrderPriceType.STOP || order.OrderType == OrderPriceType.STOPLIMIT,
    },
    OrderTimeInForce: { empty: true },
    OrderGTD: {
      empty: order.OrderTimeInForce == TimeFrame.GTD,
    },

    // The following properties are from an account.
    AccountName: {
      empty: true,
      accountLevel: true,
    },
    HolderName: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
    clientBankAccounts: {
      noBankAccountSelected:
        filteredBankAccounts &&
        filteredBankAccounts.length > 0 &&
        (order.CurrentAccount.clientBankAccount == null || order.CurrentAccount.clientBankAccount == "") &&
        !order.CurrentAccount.useCashAccount,
    },
    Quantity: {
      empty: true,
      accountLevel: true,
    },
    Instruction: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
    MarkupType: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
    CommissionType: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
  };
};

export default MFunds;
